import { render, staticRenderFns } from "./BaseDialogAdm.vue?vue&type=template&id=f91a7b12"
import script from "./BaseDialogAdm.vue?vue&type=script&lang=js"
export * from "./BaseDialogAdm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports